import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";

class ModalContactsShort extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    };

    render() {
        return (
            <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal} centered={true}>
                <ModalHeader toggle={this.toggleModal}><span>{this.props.translation.t('MODAL_FEEDBACK_TITLE_SHORT')}</span></ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-2"><span className="fas fa-phone-volume" /></div>
                        <div className="col-10"><span className='float-left'>+38 063 223 43 49</span></div>
                    </div>
                    <div className="row">
                        <div className="col-2"><span className="fas fa-at" /></div>
                        <div className="col-10"><span className='float-left'>r.tikhomirov@gmail.com</span></div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
};

export default ModalContactsShort;
